<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormBrand v-model="element.brand"/>
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormModel v-model="element.model"/>
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Matricola esterna" v-model="element.registration_external" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Matricola interna" v-model="element.registration_internal" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Sorgente lato esterno"
        v-model="element.source"
        :options="['Aria', 'Acqua']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Fluido lato utenze"
        v-model="element.fluid_user"
        :options="['Aria', 'Acqua']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Fluido frigorigeno"
        v-model="element.fluid_fridge"
        :options="['R410', 'R407C', 'R32', 'R12', 'R22', 'R134A', 'R290']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Sistema di azionamento"
        addTitle="(calcolo rcee)"
        v-model="element.drive_system"
        :options="['A ciclo di compressione con motore endotermico', 'A ciclo di compressione con motore elettrico', 'Ad assorbimento a fiamme dirette', 'Ad assorbimento per recupero di calore']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Circuiti n°" v-model="element.circuits_number" />
    </div>

    <div class="column is-12">
      <label class="checkbox">
        <input type="checkbox" v-model="element.type_cool" value="cool">
        Raffrescamento
      </label>
    </div>

    <div v-if="element.type_cool" class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Eer (gue)" v-model="element.eer" />
    </div>
    <div v-if="element.type_cool" class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Potenza frigorifera nominale" v-model="element.power_nominal_cool" addTitle="(calcolo rcee)" />
    </div>
    <div v-if="element.type_cool" class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Potenza assorbita nominale" v-model="element.power_usage_cool" />
    </div>

    <div class="column is-12">
      <label class="checkbox">
        <input type="checkbox" v-model="element.type_hot" value="hot">
        Riscaldamento
      </label>
    </div>

    <div v-if="element.type_hot" class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Cop" v-model="element.cop" />
    </div>
    <div v-if="element.type_hot" class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Potenza termica nominale" v-model="element.power_nominal_hot" addTitle="(calcolo rcee)" />
    </div>
    <div v-if="element.type_hot" class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Potenza assorbita nominale" v-model="element.power_usage_hot" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Luogo di installazione"
        v-model="element.place_of_installation"
        :options="['Interno', 'Esterno', 'Locale uso esclusivo']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Utilizzo"
        v-model="element.usage"
        :options="['ACS', 'Risc', 'Raff']"
        multiple
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Carica refrigerante (kg)" v-model="element.refrigerant_charge" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Carica ermeticamente sigillata"
        v-model="element.sealed_charge"
        :options="['Si', 'No']"
      />
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputTextarea name="Note" v-model="element.notes" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>